export interface IncomeTaxDeclarationThree {
    rows: string;
    item: string;
    originalValue: number;
    accountDepreciationAmount: number;
    taxDepreciationAmount: number;
    quickenDepreciationAmount: number;
    taxReductionAmount: number;
    discountAmount: number;
    canEdit?: boolean;
}

let list = [
    {
        rows: "1",
        item: "一、加速折旧、摊销（不含一次性扣除，2+3+4+5）",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
    },
    {
        rows: "2",
        item: "（一）重要行业固定资产加速折旧",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
        canEdit: true
    },
    {
        rows: "3",
        item: "（二）其他行业研发设备加速折旧",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
        canEdit: true
    },
    {
        rows: "4",
        item: "（三）海南自由贸易港企业固定资产加速折旧",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
        canEdit: true
    },
    {
        rows: "5",
        item: "（四）海南自由贸易港企业无形资产加速摊销",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
        canEdit: true
    },
    {
        rows: "6",
        item: "二、固定资产、无形资产一次性扣除（7+8+9+10）",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
    },
    {
        rows: "7",
        item: "（一）500万元以下设置器具一次性扣除",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
        canEdit: true
    },
    {
        rows: "8",
        item: "（二）疫情防控重点保障物资生产企业单价500万元以上设备一次性扣除",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
        canEdit: true
    },
    {
        rows: "9",
        item: "（三）海南自由贸易港企业固定一次性扣除",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
        canEdit: true
    },
    {
        rows: "10",
        item: "（四）海南自由贸易港企业无形资产加速摊销",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
        canEdit: true
    },
    {
        rows: "11",
        item: "合计（1+6）",
        originalValue: 0,
        accountDepreciationAmount: 0,
        taxDepreciationAmount: 0,
        quickenDepreciationAmount: 0,
        taxReductionAmount: 0,
        discountAmount: 0,
    },

]


let EITQuarterThree = list
export default EITQuarterThree;